<template>
    <div id="trx-ref-no-container">
      <f7-list form class="form-group" v-show="showFormInput.root.refNo">

        <f7-list-input
            input-id     ="refNo"
            name         ="refNo"
            type         ="text"

            v-show       ="showFormInput.root.refNo"
            :label       ="refNoLabel"
            :placeholder ="refNoLabel"
            :value       ="refNo"
            @input       ="setRefNo($event.target.value); validateInput($event.target); setInput($event.target)"

            maxlength    ="50"
            outline
            floating-label
            clear-button
        ></f7-list-input>
    </f7-list>
    </div>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";
  export default {
    props: {
      
    },
    mounted (){
      
    },
    data: function () {
      return {
      }
    },
    computed: {
      ...mapGetters('transaction', [
          'showFormSet',
          'showFormInput',
          'refNoLabel',
          'refNo',
      ])
    },
    methods: {
      ...mapActions('transaction', [
          'setRefNo',
      ]),

      validateInput(inputEl){
        this.$emit("validateInput", inputEl);
      },

      setInput(inputEl){
        this.$emit("setInput", inputEl);
      }

    }
  }
</script>